<template>
  <v-app-bar
    app
    class="onboarding-bar"
    height="56"
    elevate-on-scroll
  >
    <v-img
      class="onboarding-bar__img"
      :src="stiLogo"
      height="36"
      width="148.5"
      position="left center"
      contain
    />

    <v-spacer />

    <EnvironmentInfo />
    <StUserAvatar
      size="32"
      :user="user"
      user-image-path="avatarUrl"
      class="pointer"
    />
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex';
import EnvironmentInfo from '@/components/EnvironmentInfo';
import StUserAvatar from '@stilingue/st-user-avatar';
import StiLogo from '@/assets/img/sti_logo_full_black.png';

export default {
  name: 'OnboardingTopBar',
  components: {
    EnvironmentInfo,
    StUserAvatar,
  },
  data() {
    return {
      stiLogo: StiLogo,
    };
  },
  computed: {
    ...mapState('user', [
      'user',
    ]),
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
};
</script>

<style scoped lang="scss">
  $st-background-color: var(--ds-color-neutral) !important;

  .theme--dark.v-app-bar.v-toolbar {
    background-color: $st-background-color;
  }

  .onboarding-bar {
    padding: 0 var(--ds-spacing-stack-sm) !important;
    background-color: $st-background-color;
    border-bottom: 1px solid var(--ds-color-gray-3);

    &__img {
      margin: 10px 0;
    }
  }

  ::v-deep {
    .v-toolbar__content {
      padding: 0;
    }
  }
</style>
